import { c as _c } from "react/compiler-runtime";
import { CheckBadgeSolid } from '@byway/icons';
import clsx from 'clsx';
import { visuallyHidden } from '~/components/Utilities';
import styles from './PromoBadge.module.css';
type PromoBadgeProps = {
  variant?: 'card' | 'inline';
};
const LABELS = {
  card: {
    visible: 'Free upgrade',
    accessible: 'Free upgrade available for this trip'
  },
  inline: {
    visible: 'Free upgrade applied',
    accessible: 'Free upgrade applied to this trip'
  }
} as const;
const PromoBadge = t0 => {
  const $ = _c(11);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "card" : t1;
  const {
    visible,
    accessible
  } = LABELS[variant];
  const t2 = variant === "card" && styles.overlay;
  let t3;
  if ($[0] !== t2) {
    t3 = clsx(styles.badge, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CheckBadgeSolid size="scale" decorative={true} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== visible) {
    t5 = <span aria-hidden="true">{visible}</span>;
    $[3] = visible;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== accessible) {
    t6 = <span className={visuallyHidden}>{accessible}</span>;
    $[5] = accessible;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t5 || $[9] !== t6) {
    t7 = <span className={t3}>{t4}{t5}{t6}</span>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export { PromoBadge };